import { PageNameType } from './clientConfiguration/clientConfigurationSlice';

export const apiVersion = {
 results: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  approveResult: 2,
  getResultPictures: 2,
  getTableExcel: 2,
 },
 customers: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 orders: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 vehicles: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 products: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 'products/groups': {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 spy: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
  getSpyPhotos: 1,
 },
 weightings: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 drivers: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 destPoint: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  // these are not used in destPoint
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 'destPoint/details': {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 cards: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  // these are not used in cards
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 settings: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItems: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 identity: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
  generateKeyApi: 1,
  identityUserUpdate: 1,
  identityGetAccessGroups: 1,
  identityForgotPassword: 1,
  identityResetPassword: 1,
 },
 licenses: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 accessGroups: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 audit: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
 users: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
  usersGetDatabases: 1,
  usersAttachDatabase: 1,
  usersDetachDatabase: 1,
 },
 IoT: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItems: 1,
  deleteItem: 1,
  getTableStructure: 1,
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
};

export const getApiVersion = (
 table: PageNameType,
 action: keyof (typeof apiVersion)[typeof table],
) => {
 const tableConfig = apiVersion[table as keyof typeof apiVersion];
 if (!tableConfig) {
  console.error(`getApiVersion: unknown table "${String(table)}"`);
  return 1;
 }

 const version = (tableConfig as Record<string, number>)[action as string];
 if (typeof version !== 'number') {
  console.error(
   `getApiVersion: unknown action "${String(action)}" for table "${String(table)}"`,
  );
  return 1;
 }
 return version;
};

